import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    position: 'relative',
  },
  videoWrapper: {
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    transition: 'opacity 0.3s ease',
  },
  video: {
    width: '100%',
    position: 'relative',
    maxHeight: 700,
    zIndex: 2,
  },
  placeholderWrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
  placeholder: {
    position: 'relative',
    padding: theme.spacing(12, 2, 12, 2),
  },
  placeholderCircle: {
    position: 'absolute',
    left: 'calc(50% - 36px)',
    top: 'calc(50% - 36px)',
    width: '72px',
    height: '72px',
    boxSizing: 'border-box',
    borderRadius: '9999px',
    border: '2px dashed rgba(0, 0, 0, 0.3)',
    transitionProperty: 'transform, opacity',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease',
  },
  placeholderArea: {
    position: 'absolute',
    left: '12px',
    top: '12px',
    width: 'calc(100% - 24px)',
    height: 'calc(100% - 24px)',
    border: '2px dashed rgba(0, 0, 0, 0.3)',
    opacity: '0',
    backgroundColor: 'transparent',
    transitionProperty: 'background-color, opacity',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease',
  },
  placeholderDropText: {
    position: 'absolute',
    top: 'calc(50% + 48px)',
    left: '12px',
    width: 'calc(100% - 24px)',
    textAlign: 'center',
    transition: 'opacity 0.3s ease',
    color: 'rgba(0, 0, 0, 0.6)',
    pointerEvents: 'none',
  },
  arrow: {
    animation: `${keyframes`
      0% { opacity: 0, transform: translateY(-12px) }
      50% { opacity: 1, transform: translateY(0) }
      100% { opacity: 0, transform: translateY(12px) }
    `} 0.9s ease infinite`,
  },
}))
